import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class MobileLoggingService extends BaseDataService {
  url = '/api/mobilelogging';
  entityTitle = '';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  update(userIds: string[]) {
    return this.handleRequest(this.http.post(this.url, userIds), this.handlersFactory.getDefault());
  }
}
